import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  FaPlay,
  FaArrowRight,
  FaXmark,
  FaShareNodes,
  FaChevronLeft,
  FaChevronRight,
  FaCircleCheck,
} from "react-icons/fa6";
import { getEmbedUrl } from "../../../utils/helper";
import "./DigitalMediaCoverage.css";

const DIGITAL_MEDIA_DATA = [
  {
    id: 1,
    title:
      "ANI News: Union Minister Piyush Goyal Delivers Inaugural Address at Vibrant Buildcon 2025 in Delhi",
    channel: "ANI News",
    category: "TV News & National Channels",
    youtubeId: "dQw4w9WgXcQ", // Embed ID placeholder
    badge: "LIVE BROADCAST",
    thumbnail:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1000&q=80",
    description:
      "ANI News live coverage of Union Minister Shri Piyush Goyal inaugurating Vibrant Buildcon 2025 at Yashobhoomi, New Delhi. The Minister highlights how India's $5B building material export ecosystem is empowering local manufacturers.",
    tags: ["#ANINews", "#PiyushGoyal", "#VibrantBuildcon2025", "#Inauguration"],
    isFeatured: false,
  },
  {
    id: 2,
    title:
      "DD News: Union Minister Piyush Goyal Vibrant Buildcon 2025 Ka Kiya Udghatan",
    channel: "DD News",
    category: "TV News & National Channels",
    youtubeId: "dQw4w9WgXcQ",
    badge: "NATIONAL BROADCAST",
    thumbnail:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=800&q=80",
    description:
      "Doordarshan News special coverage of the grand inauguration ceremony. Over 1,000+ ceramic, stone, and structural steel exhibitors participate in India's flagship international trade expo.",
    tags: ["#DDNews", "#Buildcon2025", "#MakeInIndia"],
    isFeatured: false,
  },
  {
    id: 3,
    title:
      "Republic World: Commerce Minister Inaugurates Vibrant Buildcon 2025 at Delhi",
    channel: "Republic World",
    category: "TV News & National Channels",
    youtubeId: "dQw4w9WgXcQ",
    badge: "PRIME TIME NEWS",
    thumbnail:
      "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&w=800&q=80",
    description:
      "Republic World prime-time report on how Vibrant Buildcon 2025 connects Indian ceramic manufacturers directly with international buyer delegations from 35+ countries.",
    tags: ["#RepublicWorld", "#GlobalExports", "#CeramicCluster"],
    isFeatured: true,
  },
  {
    id: 4,
    title:
      "NEWS24: Union Minister Piyush Goyal Inaugurates Vibrant Buildcon 2025 in Delhi",
    channel: "NEWS24",
    category: "TV News & National Channels",
    youtubeId: "dQw4w9WgXcQ",
    badge: "NEWS BULLETIN",
    thumbnail:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80",
    description:
      "NEWS24 ground report covering the technical workshops, 4D BIM software demos, and sustainable green concrete formulations displayed at the expo.",
    tags: ["#NEWS24", "#ConTech", "#GreenConcrete"],
    isFeatured: false,
  },
  {
    id: 5,
    title:
      "Exclusive Interview with Union Minister Parshottam Rupala at Vibrant Buildcon Expo in Delhi",
    channel: "Bharat Buildcon Media",
    category: "Ministerial & VIP Interviews",
    youtubeId: "dQw4w9WgXcQ",
    badge: "EXCLUSIVE INTERVIEW",
    thumbnail:
      "https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&w=800&q=80",
    description:
      "Exclusive high-level interview with Hon'ble Union Minister Parshottam Rupala, discussing Gujarat's manufacturing strength and export expansion into global infrastructure markets.",
    tags: ["#ParshottamRupala", "#VIPInterview", "#TradePolicy"],
    isFeatured: false,
  },
  {
    id: 6,
    title:
      "Exclusive Interview with Union Minister Mansukh Mandaviya at Vibrant Buildcon Expo",
    channel: "Bharat Buildcon Media",
    category: "Ministerial & VIP Interviews",
    youtubeId: "dQw4w9WgXcQ",
    badge: "EXCLUSIVE INTERVIEW",
    thumbnail:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
    description:
      "Union Minister Mansukh Mandaviya shares insights on port-led export growth, bilateral trade corridors, and how Indian building materials compete on global quality standards.",
    tags: ["#MansukhMandaviya", "#PortLogistics", "#ExportGrowth"],
    isFeatured: false,
  },
  {
    id: 7,
    title:
      "What is CAPEXIL and How Does It Work? Key Insights from Secretary Harpalsingh at Vibrant Buildcon",
    channel: "CAPEXIL Official",
    category: "Industry & CAPEXIL Reports",
    youtubeId: "dQw4w9WgXcQ",
    badge: "INDUSTRY KEYNOTE",
    thumbnail:
      "https://images.unsplash.com/photo-1590486803833-1c5dc8ddd4c8?auto=format&fit=crop&w=800&q=80",
    description:
      "CAPEXIL Secretary General shares complete breakdown of chemical and allied product export benefits, government subsidies, and international trade fair participation support for Indian manufacturers.",
    tags: ["#CAPEXIL", "#ExportSubsidies", "#ChemicalsAndTiles"],
    isFeatured: false,
  },
  {
    id: 8,
    title:
      "International Buyers Forum: Housing Minister of Bahamas at Vibrant Buildcon 2025",
    channel: "Global Trade Desk",
    category: "International Buyers & Delegations",
    youtubeId: "dQw4w9WgXcQ",
    badge: "DELEGATE SPOTLIGHT",
    thumbnail:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80",
    description:
      "The Hon'ble Housing Minister of Bahamas shares high appreciation for Indian ceramic tile quality, affordable housing materials, and procurement agreements signed during the summit.",
    tags: ["#BahamasTrade", "#InternationalBuyers", "#HousingInfra"],
    isFeatured: false,
  },
  {
    id: 9,
    title:
      "Russian Federation of Builder Association: Keynote & MoU Signing at Vibrant Buildcon",
    channel: "Eurasia Trade Net",
    category: "International Buyers & Delegations",
    youtubeId: "dQw4w9WgXcQ",
    badge: "MOU SIGNING",
    thumbnail:
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80",
    description:
      "High-level delegation from the Russian Federation of Builder Association signs multi-million dollar procurement agreements for Indian porcelain slabs and sanitary fittings.",
    tags: ["#RussiaIndiaTrade", "#MoUSigning", "#InfraExports"],
    isFeatured: false,
  },
];

const VIDEOS_PER_PAGE = 6;

const DigitalMediaCoverage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // Pagination logic
  const totalPages =
    Math.ceil(DIGITAL_MEDIA_DATA.length / VIDEOS_PER_PAGE) || 1;
  const currentVideos = DIGITAL_MEDIA_DATA.slice(
    (currentPage - 1) * VIDEOS_PER_PAGE,
    currentPage * VIDEOS_PER_PAGE,
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="digital-media-page">
      <Helmet>
        <title>Digital Media Coverage | Bharat Buildcon</title>
      </Helmet>
      {/* Background Ambient Glows */}
      <div className="media-ambient-glow glow-1"></div>
      <div className="media-ambient-glow glow-2"></div>

      {/* HEADER SECTION */}
      <section className="media-header-section">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">DIGITAL MEDIA COVERAGE</span>
          </nav>
        </div>

        <h1 className="media-main-title">
          Digital Media & <span className="gradient-text">Video Showcase</span>
        </h1>

        <p className="media-subtitle-text">
          Watch broadcast TV news coverage, live ministerial keynotes, exclusive
          buyer interviews, and international trade delegation walkthroughs.
        </p>
      </section>

      {/* 3-COLUMN VIDEO CARDS GRID */}
      <section className="media-grid-section">
        <div className="media-cards-grid">
          {currentVideos.map((video) => (
            <div key={video.id} className="media-card-slot">
              <div
                className="media-video-card"
                onClick={() => setSelectedVideo(video)}
              >
                {/* Thumbnail Container */}
                <div className="card-thumb-container">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="card-thumb-img"
                  />

                  <div className="card-play-overlay">
                    <div className="card-play-btn">
                      <FaPlay className="mini-play-icon" />
                    </div>
                  </div>

                  <span className="card-channel-badge">{video.channel}</span>
                </div>

                {/* Card Content Body */}
                <div className="card-content-body">
                  <div>
                    <div className="card-meta-row"></div>

                    <h3 className="card-video-title">{video.title}</h3>
                    <p className="card-video-excerpt">{video.description}</p>
                  </div>

                  {/* Card Footer */}
                  <div className="card-footer-bar">
                    <span className="card-category-tag">{video.category}</span>

                    <button className="card-watch-link">
                      Watch <FaArrowRight />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION CONTROLS */}
        {totalPages > 1 && (
          <div className="media-pagination-bar">
            <button
              className="page-nav-btn"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaChevronLeft /> Prev
            </button>

            <div className="page-numbers-group">
              {Array.from({ length: totalPages }, (_, index) => {
                const pageNum = index + 1;
                return (
                  <button
                    key={pageNum}
                    className={`page-num-btn ${currentPage === pageNum ? "active" : ""}`}
                    onClick={() => handlePageChange(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>

            <button
              className="page-nav-btn"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next <FaChevronRight />
            </button>
          </div>
        )}
      </section>

      {/* YOUTUBE LIGHTBOX VIDEO MODAL */}
      {selectedVideo && (
        <div
          className="media-modal-backdrop"
          onClick={() => setSelectedVideo(null)}
        >
          <div
            className="media-modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-btn"
              onClick={() => setSelectedVideo(null)}
              title="Close Video Player"
            >
              <FaXmark />
            </button>

            {/* Video Player Box */}
            <div className="modal-video-wrapper">
              <iframe
                src={getEmbedUrl(selectedVideo.youtubeId)}
                title={selectedVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="modal-iframe-player"
              ></iframe>
            </div>

            {/* Video Details */}
            <div className="modal-details-body">
              <div className="modal-channel-meta">
                <span className="modal-channel-tag">
                  {selectedVideo.channel}
                </span>
                <FaCircleCheck className="modal-verify-icon" />
              </div>

              <h2 className="modal-video-heading">{selectedVideo.title}</h2>
              <p className="modal-video-full-desc">
                {selectedVideo.description}
              </p>

              <div className="modal-tags-flex">
                {selectedVideo.tags.map((tag, idx) => (
                  <span key={idx} className="modal-tag-item">
                    {tag}
                  </span>
                ))}
              </div>

              <div className="modal-actions-bar">
                <button
                  className="modal-share-btn"
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: selectedVideo.title,
                        url: window.location.href,
                      });
                    } else {
                      alert("Broadcast video link copied to clipboard!");
                    }
                  }}
                >
                  <FaShareNodes /> Share Video
                </button>

                <button
                  className="modal-close-action-btn"
                  onClick={() => setSelectedVideo(null)}
                >
                  Close Player
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalMediaCoverage;
